import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';
import util from 'util/Util.js';
import { View } from 'backbone';

import formatTemplate from 'properties/main/submit-as-child.ejs';


class MainSubmitAsChild extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[name="submitAsChildIfNoParent"]' : 'updateAttributes'
        };

        // Add needed property
        if (this.model.get('submitAsChildIfNoParent') === undefined) {
            this.model.set('submitAsChildIfNoParent',false, {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(`input[name='submitAsChildIfNoParent']`).attr('checked',util.isTrue(this.model.get('submitAsChildIfNoParent')));

        this.delegateEvents();
        return this;
    }

}

export default MainSubmitAsChild;
